module.exports = __webpack_public_path__ + "img/kit-medios-image.d0b22921.png";